import React from 'react';
// import Nav from './Nav';

// import Body from './Body';
// import case1Data from '../../sources/case1/data';
// import Amp from './Amp';
import SIOnboarding from './SIOnboarding';
import SI from './SI';
import FacilityManage from './FacilityManage';
// import Spotify from './Spotify';
// import FlightAware from './FlightAware';
// import ColorBlind from './ColorBlind';
import WorstDrivers from './WorstDrivers';
// import PhotoAlbum from './PhotoAlbum';

import Cooleaf from './Cooleaf';
import UpZone from './UpZone';
// import Hashing from './Hashing';
import Assurant from './Assurant';
import Hashing from './Hashing';

// import { NUM_OF_CONFIDENTIAL } from '../Home/data';

// import logoSVG from '../../../public/logo.svg';
// * important: If project is "confidential, **DO NOT put it here"
const cases = [
  {
    component: Cooleaf,
    sections: [
      {
        id: 'overview',
        title: 'Project Overview'
      },
      {
        id: 'research',
        title: 'Research'
      },
      {
        id: 'design',
        title: 'Define & Ideate'
      },
      {
        id: 'solution',
        title: 'Solution'
      }
    ]
  },
  {
    component: Hashing,
    // modify this for scrollTo
    sections: [
      { id: 'overview', title: 'Project Overview' },
      { id: 'research', title: 'Research' },
      { id: 'design', title: 'Design' },
      { id: 'lessons', title: 'Reflection' }
    ]
  },
  {
    component: Assurant,
    // modify this for scrollTo
    sections: [
      { id: 'overview', title: 'Project Overview' },
      { id: 'research', title: 'Research' },
      { id: 'design', title: 'Design' },
      { id: 'lessons', title: 'Reflection' }
    ]
  },
  // {
  //   component: Amp
  // },
  {
    component: SIOnboarding,
    // modify this for scrollTo
    sections: [
      { id: 'overview', title: 'Project Overview' },
      { id: 'research', title: 'Research' },
      { id: 'design', title: 'Design' },
      { id: 'lessons', title: 'Reflection' }
    ]
  },
  {
    component: UpZone,
    sections: [
      {
        id: 'overview',
        title: 'Project Overview'
      },
      {
        id: 'user-research',
        title: 'Research'
      },
      {
        id: 'ideations',
        title: 'Ideations'
      },
      {
        id: 'prototype',
        title: 'Prototype'
      }
    ]
  },
  {
    component: SI,
    sections: [
      { id: 'overview', title: 'Project Overview' },
      { id: 'process', title: 'Research Process' },
      { id: 'siteMap', title: 'Sitemap' },
      { id: 'wireframes', title: 'Wireframes' }
    ]
  },
  {
    component: FacilityManage,
    sections: [
      { id: 'overview', title: 'Project Overview' },
      { id: 'projectactivities', title: 'Project Activities' },
      { id: 'outcomes', title: 'Outcomes' }
    ]
  },
  // {
  //   component: Spotify,
  //   sections: [
  //     { id: 'designGoal', title: 'Design Goal' },
  //     { id: 'background', title: 'Background' },
  //     { id: 'userFlow', title: 'User Flow' },
  //     { id: 'loFi', title: 'Wireframe' },
  //     { id: 'hiFi', title: 'Hi-Fi UI' }
  //   ]
  // },
  // {
  //   component: FlightAware,
  // },
  // {
  //   component: PhotoAlbum,
  //   sections: [
  //     { id: 'overview', title: 'Project Overview' },
  //     { id: 'introduction', title: 'Introduction' },
  //     { id: 'researchProcess', title: 'Research Process' },
  //     { id: 'design', title: 'Design Process & Evaluation' }
  //   ]
  // },
  {
    component: WorstDrivers,
    sections: [
      { id: 'overview', title: 'Project Overview' },
      { id: 'background', title: 'Background' },
      { id: 'dataCollection', title: 'Data Collection' },
      { id: 'design', title: 'Design & Implementation' }
    ]
  }
  // {
  //   component: ColorBlind,
  //   sections: [
  //     { id: 'overview', title: 'Project Overview' },
  //     { id: 'researchProcess', title: 'Research' },
  //     { id: 'designProcess', title: 'Design' },
  //     { id: 'outcomes', title: 'Outcomes' }
  //   ]
  // }
];

const caseMap = cases.reduce((acc, item, index) => {
  acc[`case${index}`] = item;
  return acc;
}, {});

// const NUM_OF_CASES = cases.length - NUM_OF_CONFIDENTIAL;

const Case = ({ match }) => {
  const theCase = match.params.case;
  // const currentCaseIndex = Number(theCase.replace('case', ''));
  return (
    <div>
      {/* <Nav
        currentCase={currentCaseIndex}
        sections={caseMap[theCase].sections}
        done={currentCaseIndex === NUM_OF_CASES - 1}
      /> */}
      {/* <div className=" case-header">
        <ul className="nav">
          <li className="to-home">
            <a className="nav-link link navTo" href="/">
              <img src={logoSVG} alt="" />
            </a>
          </li>
        </ul>
      </div> */}
      {React.createElement(caseMap[theCase].component)}
    </div>
  );
};

export default Case;



// WEBPACK FOOTER //
// ./src/Modules/Case/Case.js